import { aftermovies } from '~/data/links';

type AftermovieYear = keyof typeof aftermovies;

export function AfterMoviesBar() {
  const years = (Object.keys(aftermovies) as unknown as AftermovieYear[]).sort((a, b) => Number(b) - Number(a));

  return (
    <div className="mt-[55px] bg-yellow py-1 text-[10px] md:text-sm lg:mt-[60px]">
      <div className="container mx-auto flex flex-col items-center justify-center gap-1 overflow-x-auto px-4 md:flex-row md:gap-4">
        <span className="whitespace-nowrap text-beige3">Aftermovies:</span>
        <div className="flex items-center gap-4 overflow-x-auto whitespace-nowrap">
          {years.map(year => (
            <a
              key={year}
              href={aftermovies[year]}
              target="_blank"
              rel="noreferrer noopener"
              className="text-beige3 transition-colors hover:text-red/80"
              data-umami-event="aftermovie"
              data-umami-event-year={year}
              aria-label={`Watch ${year} aftermovie (opens in new tab)`}
            >
              {year}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
